import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { JOB_STATES, QUEUE_NAMES } from '@/features/activity/jobs/api';
import { JobsPage } from '@/features/activity/jobs/jobs-page';

// S18 · Jobs (07 §5). `?queue=` and `?state=` filter the jobs table; `?job=<id>`
// (the S17 drawer's link) shows that job highlighted with its error open, fetched alone when not in the page.
export const Route = createFileRoute('/_app/activity/jobs')({
  validateSearch: z.object({
    queue: z.enum(QUEUE_NAMES).optional().catch(undefined),
    state: z.enum(JOB_STATES).optional().catch(undefined),
    job: z.string().max(128).optional().catch(undefined),
  }),
  component: JobsPage,
});
